<template>
    <div class="filter-view">
        <button
            role="button"
            class="filter-view__toggle | btn btn--alt"
            @click="isOpen = !isOpen"
        >
            {{ this.$root.trans.filtersBtn }}
            <span
                v-if="selectedFilters.length"
                class="filter-view__toggle__counter | counter"
                v-html="selectedFilters.length"
            />
        </button>
        <div
            class="filter-panel"
            :class="{ 'is-open': isOpen }"
        >
            <button
                class="filter-panel__close | close | btn btn--cta btn--rounded"
                role="button"
                @click="isOpen = false"
            >
                <img src="/img/ui/icon-cross.svg" alt="Close" class="filter-panel__close-icon | icon icon--close">
            </button>
            <div class="filter-panel__inner">
                <header class="filter-panel__header">
                    <h1 class="title title--xl">{{ this.$root.trans.filtersTitle }}</h1>
                    <p>{{ this.$root.trans.selectFiltersCaption }}</p>
                </header>
                <div class="filter-panel__content">
                    <ul class="filter-panel__list">
                        <li
                            :key="selection_id"
                            v-for="(selection, selection_id) in selections"
                            class="filter-panel__el"
                        >
                            <label :for="`cb-filter-${selection_id}`">
                                <input
                                    type="checkbox"
                                    :id="`cb-filter-${selection_id}`"
                                    :value="selection_id" v-model="selectedFilters"
                                    class="visually-hidden"
                                />
                                <div class="filter-panel__label">
                                    <img
                                        :src="selection.icon"
                                        alt=""
                                        class="filter-panel__icon"
                                    />
                                    <span v-html="selection.name" />
                                </div>
                            </label>
                        </li>
                    </ul>
                </div>
                <footer class="filter-panel__footer">
                    <button
                        class="filter-panel__footer__btn | btn btn--cta"
                        role="button"
                        @click="isOpen = false"
                    >
                        {{ this.$root.trans.validFiltersBtn }}
                    </button>
                    <button
                        class="filter-panel__footer__btn | btn"
                        role="reset"
                        @click="onClear"
                    >
                        {{ this.$root.trans.resetFiltersBtn }}
                    </button>
                </footer>
            </div>
        </div>
        <div
            class="filter-view__darkener"
            @click="isOpen = false"
        />
    </div>
</template>

<script>

export default {

    /* Settings
    --------------------------------------------------------- */

    name: 'FilterPanel',


    components: {
        //
    },


    props: {
        selections: { type: Object, required: true },
    },


    data() {
        return {
            selectedFilters: [],
            isOpen: false,
        }
    },



    /* Data Handling
    --------------------------------------------------------- */


    computed: {
        //
    },

    watch: {
        isOpen: function(isOpen) { // eslint-disable-line
            this.$emit('filters:toggle', isOpen)
        },
        // selections: function(newSelection, oldSelection) { // eslint-disable-line
        //     this.selectedFilters = Object.keys(newSelection)
        // },

        selectedFilters: function(newSelection, oldSelection) { // eslint-disable-line
            this.$emit('selections:change', this.getSelectionIds())
        },
    },



    /* Methods
    --------------------------------------------------------- */

    methods: {

        getSelectionIds() {
            if (this.selectedFilters.length === 0) {
                // if nothing is selected, return all!
                return Object.keys(this.selections).map(id => parseInt(id, 10))
            }
            return this.selectedFilters.map(id => parseInt(id, 10))
        },

        /* Handlers
        --------------------------------------------------------- */

        reset() {
            this.selectedFilters = []
        },

        onClear() {
            this.reset()
        },
    },
}
</script>
